import { Dispatch, SetStateAction } from "react";
import FourDPQuiz from "./FourDPQuiz";
import {
  FourDPQuizResultsType,
  TrainingProgressionUpdateType,
} from "@WahooFitness/cloud-client-types";
import QuizContainer from "../QuizContainer";

function FourDPQuizContainer({
  setResults,
  setError,
  setPage,
  skipEducation,
  setInitialTrainingProgression,
  onFirstStepBack,
}: {
  setResults: Dispatch<SetStateAction<FourDPQuizResultsType | undefined>>;
  setError: Dispatch<SetStateAction<string | undefined>>;
  setPage: Dispatch<SetStateAction<number>>;
  skipEducation: boolean;
  setInitialTrainingProgression: Dispatch<
    SetStateAction<TrainingProgressionUpdateType | undefined>
  >;
  onFirstStepBack?: () => void;
}) {
  return (
    <QuizContainer
      renderQuiz={(user) => (
        <FourDPQuiz
          user={user}
          setError={setError}
          setResults={setResults}
          setPage={setPage}
          skipEducation={skipEducation}
          setInitialTrainingProgression={setInitialTrainingProgression}
          onFirstStepBack={onFirstStepBack}
        />
      )}
    />
  );
}

export default FourDPQuizContainer;
